// extracted by mini-css-extract-plugin
export default {"button":"loginButton__button--xyYDm","login":"loginButton__login--fRriI"};